import { Grid } from '@mui/material';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import {
  getJobBoardByJBName,
  IJobBoardDTO,
  getJobBoardDetailsByName,
  usersAdvanceFilterQuery,
} from 'wisestep-api';
import { WsAutoComplete, WsButton } from 'wisestep-base';

import { useNativeSearchQueryStore } from '../store/NativeSearchQueryStore';

interface SearchSharedUserProp {
  jobBoardName?:
    | 'DICE_SEARCH'
    | 'CAREER_BUILDER'
    | 'CAREER_BUILDER_EDGE'
    | 'TECH_FETCH'
    | 'CV_LIBRARY'
    | 'MONSTER'
    | 'JOB_SERVE'
    | 'CW_JOBS'
    | 'JOB_SITE';
  setAccounts?: (accounts: IJobBoardDTO[]) => void;
  isListing?: boolean;
  searchSharedAccount?: (email: string) => void;
}

const SearchSharedUser = ({
  jobBoardName = 'DICE_SEARCH',
  setAccounts = () => {},
  isListing = true,
  searchSharedAccount = () => {},
}: SearchSharedUserProp) => {
  const [suggestionsData, setSuggestionData] = useState<string[]>([]);

  const setEmail = useNativeSearchQueryStore((state) => state.setEmail);
  const searchEmail = useNativeSearchQueryStore((state) => state.email);
  const fetchJobBoardAcc = async (data: any) => {
    if (isListing) {
      let response;
      if (jobBoardName === 'MONSTER') {
        response = await getJobBoardDetailsByName(jobBoardName, '', data['userEmail']);
      } else {
        response = await getJobBoardByJBName(jobBoardName, data['userEmail']);
      }
      if (response.data) setAccounts(response.data);
    } else {
      searchSharedAccount(data['userEmail']);
    }
    setEmail(data['userEmail']);
  };
  const formOptions = {};

  const methods = useForm(formOptions);
  const { handleSubmit, setValue } = methods;

  const onEmailSelect = (selectedEmail: string[]) => {
    setValue('userEmail', selectedEmail?.[0] ?? '');
    setEmail(selectedEmail?.[0] ?? '');
  };

  const workspaceRecruiterSearchAPI = async (query: string) => {
    if (query.length >= 2) {
      const tempArray: string[] = [];
      const workspaceRecruiterSuggestions = await usersAdvanceFilterQuery(query);
      workspaceRecruiterSuggestions.data.map((data) => tempArray.push(data.userId));
      setSuggestionData(tempArray);
    }
  };
  return (
    <Grid container>
      <FormProvider {...methods}>
        <Grid
          spacing={1}
          ml={0.18}
          container
          py={1}
          pr={1}
          display="flex"
          justifyContent="end"
          sx={{ backgroundColor: 'white' }}
        >
          <Grid item xs={4}>
            <WsAutoComplete
              onValueEnter={workspaceRecruiterSearchAPI}
              onTagsChange={onEmailSelect}
              placeholder="workspace user email"
              initialValue={[]}
              optionsInStringArray={suggestionsData}
              multiple={false}
              freeSolo={false}
              name="userEmail"
              size="small"
              required={true}
              variant="outlined"
              value={searchEmail ? searchEmail : ''}
            />
          </Grid>

          <Grid item xs={2}>
            <WsButton
              type="submit"
              onClick={handleSubmit(fetchJobBoardAcc)}
              variant="outlined"
              size="large"
              fullWidth={true}
            >
              Search
            </WsButton>
          </Grid>
        </Grid>
      </FormProvider>
    </Grid>
  );
};

export default SearchSharedUser;
